export default "__VITE_ASSET__C0xIq4s$__"